import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cloneElement, memo } from 'react';
import { useTheme } from 'styled-components';
import { NotificationIndicator } from '../../../../Elements/NotificationIndicator/index.js';
import { ItemHeaderWrapper, ItemIcon, ItemTitle, ItemTitleText, Label, NotificationIndicatorWrapper } from './styled.js';
export const HeaderWrapper = memo(function HeaderWrapper({ match, icon, title, label, showIndicator, isCollapsedNav }) {
    const theme = useTheme();
    const clonedIcon = cloneElement(icon, {
        filled: !!match,
        color: match ? theme.colors.main : theme.colors.grey100_1,
        size: 20,
    });
    return (_jsxs(_Fragment, { children: [showIndicator && isCollapsedNav && (_jsx(NotificationIndicatorWrapper, { children: _jsx(NotificationIndicator, { warning: true }) })), _jsxs(ItemHeaderWrapper, { children: [_jsx(ItemIcon, { children: clonedIcon }), _jsxs(ItemTitle, { children: [_jsx(ItemTitleText, { children: title }), showIndicator && !isCollapsedNav && _jsx(NotificationIndicator, { warning: true }), label && _jsx(Label, { children: label })] })] })] }));
});
